$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('home-advantage')) {
    customElements.define(
      'home-advantage',
      class aboutApplicationScenarios extends HTMLElement {
        swiper = null;
        constructor() {
          super();
        }

        connectedCallback() {
          const _this = this;
          this.init();
          const $advantageBtnItem = $(this.querySelectorAll('.advantage-btn_item'));
          // const $advantageSlideContent = $(this.querySelectorAll('.swiper-slide_content'));
          // $advantageSlideContent.first().removeClass('hidden');
          $advantageBtnItem.first().css('color', 'white').css('background-color', 'black');
          $advantageBtnItem.on('click', function () {
            $advantageBtnItem.css('color', '#191919').css('background-color', 'white');
            $(this).css('color', 'white').css('background-color', 'black');
            _this.swiper.slideToLoop(this.dataset.index);
          });
        }

        init() {
          const $mySwiper = this.querySelector('.home-advantage_swiper');
          const advantagePrev = this.querySelector('.home-advantage_prev');
          const advantageNext = this.querySelector('.home-advantage_next');
          const _this = this;

          this.swiper = new Swiper($mySwiper, {
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            speed: 600,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
            },
            spaceBetween: 24,
            slidesPerView: 'auto',
            navigation: {
              nextEl: advantageNext,
              prevEl: advantagePrev,
            },
            on: {
              slideChangeTransitionStart: function () {
                const $currentAdvantageBtnItem = $(_this.querySelector(`[data-index='${this.realIndex}']`));
                const $advantageBtnItem = $(_this.querySelectorAll('.advantage-btn_item'));
                $advantageBtnItem.css('color', '#191919').css('background-color', 'white');
                $currentAdvantageBtnItem.css('color', 'white').css('background-color', 'black');
                // const $advantageBtnContainer = $(_this.querySelector('.advantage-btn_container'));

                // 当前按钮滚动到可视范围;
                const $advantageBtnContainer = $(_this.querySelector('.advantage-btn_container'));
                // 获取滚动容器的滚动位置
                const scrollLeft = $advantageBtnContainer.scrollLeft();
                // 获取目标元素的边界矩形
                const rect = $currentAdvantageBtnItem.offset();
                // 获取滚动容器的边界矩形
                const containerRect = $advantageBtnContainer.offset();
                // 获取滚动容器的padding 去掉px
                const containerPadding = $advantageBtnContainer.css('padding-left').replace('px', '');

                // 计算目标滚动位置
                const targetScrollLeft =
                  rect.left +
                  scrollLeft -
                  $(window).width() / 2 +
                  $currentAdvantageBtnItem.width() / 2 +
                  +containerPadding;
                // 执行滚动动画
                $advantageBtnContainer.animate({ scrollLeft: targetScrollLeft }, 100);

                // const offset = $currentAdvantageBtnItem.offset().left;
                // const elementWidth = $currentAdvantageBtnItem.width();
                // const windowWidth = $(window).width();

                // $currentAdvantageBtnItem.parent().animate(
                //   {
                //     scrollLeft: offset - windowWidth / 2 + elementWidth / 2,
                //   },
                //   100
                // );
              },
            },
          });
        }
      }
    );
  }
});
